import {
  Card,
  List,
  Typography,
  Tag,
  Empty,
  Divider,
  Button,
  Popconfirm,
  Space,
  App,
  Modal
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  PrinterOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { sendBillAction } from "../../components/action/SendBillAction";
import { useState } from "react";
import Invoice from "../../components/invoices/View";

const { Text } = Typography;

const CARD_STYLE = {
  borderRadius: 16,
  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  height: "85vh",
  width: "95%",
  margin: "20px auto",
  display: "flex",
  flexDirection: "column",
};

const SaveBill = ({ ListOfSaveBill, onPrint }) => {
  const navigate = useNavigate();
  const { message } = App.useApp();

  const [selectedBill, setSelectedBill] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleEdit = (bill) => {
    navigate("/order-processing/grid");
    localStorage.setItem("billId", bill.Bill_ID);
    sendBillAction("edit-bill", {}, {}, message);
  };

  const handleDelete = (bill) => {
    localStorage.setItem("billId", bill.Bill_ID);
    sendBillAction("delete-bill", {}, {}, message);
    localStorage.removeItem("billId");
  };

  const handlePrint = (bill) => {
    if (onPrint) onPrint(bill);
    else message.info(`Printing bill ${bill.Bill_ID}`);
  };

  const handleViewInvoice = (bill) => {
    setSelectedBill(bill);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedBill(null);
    setIsModalOpen(false);
  };

  const checkBillId = localStorage.getItem("billId");

  return (
    <Card style={CARD_STYLE}>
      {(ListOfSaveBill ?? []).length === 0 ? (
        <Empty description="No bills yet" />
      ) : (
        <div>
          <List
            bordered
            dataSource={ListOfSaveBill ?? []}
            style={{ maxHeight: "520px", overflowY: "auto" }}
            renderItem={(bill) => (
              <List.Item
                actions={[
                  <Space align="center" key="actions">
                    <Button
                      type="default"
                      icon={<EyeOutlined />}
                      onClick={() => handleViewInvoice(bill)}
                    >
                      View Invoice
                    </Button>
                    <Button
                      type="default"
                      icon={<EditOutlined />}
                      onClick={() => handleEdit(bill)}
                      disabled={checkBillId !== null ? true : false}
                    >
                      Edit
                    </Button>
                    <Popconfirm
                      title="Delete this bill?"
                      onConfirm={() => handleDelete(bill)}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button danger icon={<DeleteOutlined />} />
                    </Popconfirm>
                    <Button
                      type="primary"
                      icon={<PrinterOutlined />}
                      onClick={() => handlePrint(bill)}
                    >
                      Print
                    </Button>
                  </Space>,
                ]}
              >
                <div>
                  <Text strong style={{ display: "inline-block", width: 100 }}>ID: {bill.Bill_ID} </Text>
                  <Tag color="orange" strong style={{ display: "inline-block", width: 100, marginRight: "20px" }}>Total: ${(bill.Total ?? 0).toFixed(2)} </Tag>
                  <Tag color="green" style={{ marginRight: "20px", width: 120 }}><Text strong>Created:</Text> {bill.Created_Time}</Tag>
                  <Text strong style={{ display: "inline-block", width: 150 }}>Debtor: {bill.Bill_Name}</Text>
                </div>
              </List.Item>
            )}
          />
          <Divider />
          <Text strong>
            🧾 Total Bill: $
            {((ListOfSaveBill ?? []).reduce((sum, b) => sum + (b.Total ?? 0), 0)).toFixed(2)}
          </Text>
        </div>
      )}

      {/* Modal for Invoice */}
      <Modal
        open={isModalOpen}
        onCancel={handleCloseModal}
        footer={null}
        width={500}
        centered
        title={<p style={{ fontSize: "20px" }}>Invoice Detail</p>}
      >
        {selectedBill && <Invoice invoices={selectedBill} />}
      </Modal>
    </Card>
  );
};

export default SaveBill;
